import $ from 'jquery';

$.dim = () => {
  const { body } = document;

  if (document.getElementById('dimmer') == null) {
    const div = document.createElement('div');
    div.setAttribute('id', 'dimmer');
    body.appendChild(div);
  }

  setTimeout(() => {
    body.classList.add('dimmed');
  }, 10);
};

$.undim = () => {
  document.body.classList.remove('dimmed');
};
